module.exports = __webpack_public_path__ + "img/logo-competti-big.4ac60055.png";